import { Link } from 'react-router-dom';
import { ContactInfo, ContactType } from '../../home/models/ContactInfo';
import { Utils } from './Utils';

type FooterProps = {
    contacts: ContactInfo[];
}

export default function FooterView({ contacts }: FooterProps) {
    const urls = contacts.filter((value: ContactInfo) =>
        value.type === ContactType.url);

    const desktopView = () => {
        const width4 = Utils.getColumnWidth(4, 4, 12);
        const width8 = Utils.getColumnWidth(8, 8, 12);

        return <div className="ms-Grid">
            <div className="ms-Grid-row pv-20 ph-15 font-smaller" style={{ background: "#f8f9f9" }}>
                <div className={width8 + " left"}>
                    <span><Link to="/general-policy">General Policy</Link></span>
                    <span className="link-separator">|</span>
                    <span><Link to="/privacy">Privacy Policy</Link></span>
                    <span className="link-separator">|</span>
                    <span><Link to="/price-policy">Price Policy</Link></span>
                    <span className="link-separator">|</span>
                    <span><Link to="/terms">Terms of Use</Link></span>
                    <span className="link-separator">|</span>
                    <span><Link to="/userDeletion">User Deletion</Link></span>
                </div>
                <div className={width4 + " right"}>
                    {printCompanyContacts()}
                </div>
            </div>
        </div>;
    }

    const mobileView = () => {
        return <div className="ms-Grid pv-15" style={{ background: "#f8f9f9" }}>
            <div className="ms-Grid-row pb-10">{policyView1()}</div>
            <div className="ms-Grid-row pb-10">{policyView2()}</div>
            <div className="ms-Grid-row">{printCompanyContacts()}</div>
        </div>;
    }

    const policyView1 = () => {
        return <>
            <span><Link to="/general-policy">General Policy</Link></span>
            <span className="link-separator">|</span>
            <span><Link to="/privacy">Privacy Policy</Link></span>
            <span className="link-separator">|</span>
            <span><Link to="/price-policy">Price Policy</Link></span>
        </>;
    }

    const policyView2 = () => {
        return <>
            <span><Link to="/terms">Terms of Use</Link></span>
            <span className="link-separator">|</span>
            <span><Link to="/userDeletion">User Deletion</Link></span>
        </>;
    }

    const printCompanyContacts = () => {
        return <>
            {!Utils.isArrayNullOrEmpty(urls) && <>
                <span className="pr-20">Links:</span>

                {urls.map((contact: ContactInfo, index: number) => {
                    return <div style={{ display: "inline-block" }}>
                        {index > 0 && <span className="link-separator">|</span>}
                        <a
                            href={contact.account1}
                            target="_blank"
                            className="clickable"
                        >{contact.name}</a>
                    </div>;
                })}
            </>}
        </>;
    }

    if (Utils.isMobile()) {
        return <>{mobileView()}</>;
    } else {
        return <>{desktopView()}</>;
    }
}